import { Component } from '@verndale/core';
import { ConditionalDisplay } from '../helpers/global';
import { ReplaceHeading } from '../helpers/global';

type AirportDataType = {
  name: string;
  distance: string;
}[];

class Transportation extends Component {
  setupDefaults() {
    this.dom = {
      barWrapper: this.el.querySelectorAll('.v-transportation__bar-wrapper'),
      smBar: this.el.querySelectorAll('.v-transportation__sm-bar-wrapper'),
      heading: this.el.querySelectorAll('.v-transportation__heading'),
      airportWrapper: this.el.querySelector('.v-transportation__airports') as HTMLElement
    };
    if (ConditionalDisplay(this.el.id)) {
      this.el.style.display = 'none';
    }
    this.updateBarValues();
    this.updateSmBarValues();

    (this.dom.heading as NodeListOf<HTMLElement>).forEach(heading => {
      ReplaceHeading(heading);
    });

    const mobileQuery = window.matchMedia('(max-width: 767px)');

    mobileQuery.addEventListener('change', () => this.updateSmBarValues());
  }

  updateBarValues() {
    (this.dom.barWrapper as NodeListOf<HTMLElement>).forEach(bar => {
      const value = bar.querySelector('.v-transportation__bar-value') as HTMLElement;
      const barFill = bar.querySelector('.v-transportation__progress-bar');
      if (barFill && value) {
        (barFill as HTMLElement).style.setProperty(
          'inset-inline-end',
          `calc(100% - ${value.innerText})`
        );
      }
    });
  }

  capitalizeFirstLetter(text: string) {
    return text
      .split(' ')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }

  updateSmBarValues() {
    const mobile = window.innerWidth < 768;
    const miles = document.body.dataset.metric === 'miles' ? true : false;
    const airportDataset = (this.dom.airportWrapper as HTMLElement).dataset;
    const airportData = airportDataset.airportData ? JSON.parse(airportDataset.airportData) : null;

    if (!airportData) return;

    // find the largest value
    const largestValue = Math.max(
      ...(airportData as AirportDataType).map(airport =>
        parseInt(airport.distance.replace(/[^0-9.-]+/g, ''))
      )
    );

    (this.dom.smBar as NodeListOf<HTMLElement>).forEach((bar, index) => {
      const valueElement = bar.querySelector('.v-transportation__sm-value');
      const distanceValue = airportData[index]?.distance;
      let percentage = 0;

      if (!distanceValue || !valueElement) return;

      const valueInt = parseInt(distanceValue.replace(/[^0-9.-]+/g, ''));
      const heading = bar.querySelector('.v-transportation__bar-heading');
      const headingText = airportData[index]?.name;

      if (miles) {
        valueElement.innerHTML = `${(valueInt * 0.621371).toFixed(1)} mi`;
        percentage = (valueInt / 0.621371 / largestValue) * (mobile ? 80 : 60);

        if (heading && headingText) {
          heading.textContent = headingText;
        }
      } else {
        if (heading && headingText) {
          heading.textContent = this.capitalizeFirstLetter(headingText);
        }

        percentage = (valueInt / largestValue) * (mobile ? 80 : 60);
        valueElement.innerHTML = distanceValue;
      }

      const barFill = bar.querySelector('.v-transportation__bar');

      if (barFill && percentage) {
        (barFill as HTMLElement).style.setProperty('flex-basis', `${percentage}%`);
      }
    });
  }
}

export default Transportation;
